module.exports = __webpack_public_path__ + "assets/img/newlogin.79dde74c.png";